import { useState } from 'react'

export default function Assets() {
  const [assets] = useState([
    { id: 1, name: 'banner-01.jpg', type: '图片', size: '2.3MB', url: '#999', createdAt: '2026-04-17' },
    { id: 2, name: 'activity-video.mp4', type: '视频', size: '156MB', url: '#999', createdAt: '2026-04-15' },
    { id: 3, name: 'bg-music.mp3', type: '音频', size: '4.5MB', url: '#999', createdAt: '2026-04-12' },
  ])

  const getIcon = (type) => {
    const map = { '图片': '🖼', '视频': '🎬', '音频': '🎵' }
    return map[type] || '📄'
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📁 素材管理</h2>

      <div style={{ background: '#fff', borderRadius: 8, padding: 20, marginBottom: 20 }}>
        <button style={{ padding: '10px 20px', background: '#fff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>+ 上传素材</button>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>预览</th>
              <th style={th}>文件?</th>
              <th style={th}>类型</th>
              <th style={th}>大小</th>
              <th style={th}>上传时间</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {assets.map(a => (
              <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ ...td, fontSize: 28, textAlign: 'center', width: 60 }}>{getIcon(a.type)}</td>
                <td style={td}>{a.name}</td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#fff', color: '#666' }}>{a.type}</span></td>
                <td style={{ ...td, color: '#999' }}>{a.size}</td>
                <td style={{ ...td, color: '#999' }}>{a.createdAt}</td>
                <td style={td}>
                  <button style={{ ...btn, background: '#1890ff', color: '#666' }}>复制链接</button>
                  <button style={{ ...btn, background: '#ff4d4f', color: '#999', marginLeft: 8 }}>删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
